import React from "react";

const MLBPlayerSummaryContext = React.createContext({});

export default MLBPlayerSummaryContext;
